import { Flex } from '@backyard-ui/core'

import { Button } from '../Button'

export interface ButtonProps {
  key: string
  label: string
  isDisabled?: boolean
  confirmOnActionMessage?: string
}

interface ButtonsGroupProps {
  buttons: ButtonProps[]
  onClick: (key: string) => void
}

const ButtonsGroup = (props: Readonly<ButtonsGroupProps>) => {
  const { buttons, onClick } = props
  return (
    <Flex wrap="wrap" className="gap-4">
      {buttons.map(button => (
        <Button
          key={button.key}
          data={button}
          onClick={() => onClick(button.key)}
          isDisabled={button.isDisabled}
          confirmOnActionMessage={button.confirmOnActionMessage}
        />
      ))}
    </Flex>
  )
}

export default ButtonsGroup
